const tabPanel = class extends HTMLElement {
  constructor () {
    super()
    this.tabs = this.querySelectorAll('[data-tab]')
    this.tabPanels = this.querySelectorAll('[data-tabpanel]')
  }

  connectedCallback () {
    this.tabs.forEach((tab, index) => {
      tab.addEventListener('click', () => { this.updateSelectedTab(tab) })
      tab.addEventListener('keydown', (e) => { this.handleKeydown(e, index) })
    })
  }

  handleKeydown (event, index) {
    const { key } = event
    let newIndex = index

    if (key === 'ArrowRight' || key === 'ArrowDown') {
      newIndex = (index + 1) % this.tabs.length
    } else if (key === 'ArrowLeft' || key === 'ArrowUp') {
      newIndex = (index - 1 + this.tabs.length) % this.tabs.length
    }

    if (newIndex === index) return
    this.tabs[newIndex].focus()
    this.updateSelectedTab(this.tabs[newIndex])
  }

  updateSelectedTab (activeTab) {
    this.tabs.forEach(tab => {
      tab.setAttribute('aria-selected', tab === activeTab ? 'true' : 'false')
      tab.setAttribute('tabindex', tab === activeTab ? '0' : '-1')
    })

    this.tabPanels.forEach(tabPanel => {
      tabPanel.setAttribute('aria-hidden', activeTab.getAttribute('aria-controls') === tabPanel.id ? 'false' : 'true')
      tabPanel.hidden = activeTab.getAttribute('aria-controls') !== tabPanel.id

      if (!tabPanel.hidden) {
        const event = new CustomEvent('tab-changed')
        tabPanel.dispatchEvent(event)
      }
    })
  }
}

if (typeof window.customElements.get('tab-panel') === 'undefined') {
  window.customElements.define('tab-panel', tabPanel)
}